import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VideoCatalogCdpHeroslider from "./component";
import { withRouter } from "react-router-dom";
import { setVideoGalleryModalOpen } from "../video-gallery/actions";

const mapStateToProps = ({
    carDetails: {
        content,
        config
    },
    videoGallery: {
        isVideoGalleryModalOpen
    },
    tradeIn: {
        userTradeInData,
        tradeInToggleSelected
    },
    user: {isUserZeroDpVariant},
    abExperiment: {
        desktopPremiumFeatures,
        hideImperfectionsDesktop
    }
}) => ({
    content,
    config,
    isVideoGalleryModalOpen,
    userTradeInData,
    tradeInToggleSelected,
    isUserZeroDpVariant,
    desktopPremiumFeatures,
    hideImperfectionsDesktop
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setVideoGalleryModalOpenConnect: setVideoGalleryModalOpen
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoCatalogCdpHeroslider));
